onComplete(function() {
	// The price slider of the housing filters writes raw numbers (119500); show them as Dutch amounts (119.500).
	// The slider rewrites the text on every move, so an observer formats each new value.
	const formatAmount = function(output) {
		const text = output.textContent.trim();
		if (/^\d+$/.test(text)) {
			output.textContent = parseInt(text, 10).toLocaleString('nl-NL');
		}
	};
	document.querySelectorAll('.blog-filters [data-output^="range-amount"]').forEach(function(output) {
		formatAmount(output);
		new MutationObserver(function() {
			formatAmount(output);
		}).observe(output, { childList: true, characterData: true, subtree: true });
	});
});
